import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { setVineyardTypes, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import validate from '../components/Validations/submitValidationsVineyardTypesForm';
import VineyardTypesForm from '../components/VineyardTypesForm';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setVineyardTypes(values, dispatch) {
            dispatch(submitForm());
            let errors = validate(values);
            if ( Object.keys(errors).length !== 0) {
                const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
                return sleep(10).then(() => {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...errors, _error: 'Revisá los campos indicados.' })
                })
            }
            return dispatch(setVineyardTypes(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VineyardTypesForm);


/** WEBPACK FOOTER **
 ** ./src/containers/VineyardTypesFormContainer.js
 **/